// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2tJMk","selects":"Documents_selects__vVcf_"};